import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdapterService } from './services/adapter.service';
import { ProductService } from './services/product.service';
import { NotificationService } from './services/notification.service';
import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { CalculatorService } from './services/calculator.service';
import { OrderService } from './services/order.service';
import { AppHttpInterceptor } from './interceptors/api.interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-handler.interceptor.ts';


@NgModule({
  declarations: [
  ],
  imports: [
    HttpClientModule
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        "CoreModule is already loaded. Import it in the AppModule only");
    }
  }
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: "AdaptersService", useClass: AdapterService },
        { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
        ProductService,
        NotificationService,
        AuthService,
        UserService,
        CalculatorService,
        OrderService
      ]
    }
  }
}

